module.exports = __webpack_public_path__ + "static/media/glasses_jeff.6d02ca02.jpg";